import React, { forwardRef } from 'react';
import { styleIcon } from '../style_icon.js';
export const MoreIcon = forwardRef(({ title = 'More Icon', ...rest }, ref) => {
    const props = styleIcon(rest);
    return (React.createElement("svg", { ...props, ref: ref, viewBox: "0 0 4 16" },
        !props['aria-hidden'] && React.createElement("title", null, title),
        React.createElement("path", { d: "M1.93 0h.14C3.19 0 4 .83 4 2s-.81 2-1.93 2h-.14C.81 4 0 3.17 0 2s.81-2 1.93-2m.14 6h-.14C.81 6 0 6.83 0 8s.81 2 1.93 2h.14C3.19 10 4 9.17 4 8s-.81-2-1.93-2m0 6h-.14C.81 12 0 12.83 0 14s.81 2 1.93 2h.14C3.19 16 4 15.17 4 14s-.81-2-1.93-2" })));
});
//# sourceMappingURL=more_icon.js.map